import { request } from '@/shared/api/request'

export const rejectTradeUnion = async (externalId, isEmployee) => {
	return request({ url: `colcontract/ecd/tradeUnion/reject/${externalId}?isEmployee=${isEmployee}`, method: 'POST' })
}
